import {BaseUtils} from "./base-utils";

export class MathUtils extends BaseUtils {
  formatNumber(number){
    const formatter = new Intl.NumberFormat('en-US');
    return formatter.format(number);
  }
}
